import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);
  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-6">
        {hasIntro ? (
          <RavioliCommonContent
            alignment={alignment}
            buttons={buttons}
            className="self-start border border-primary bg-collection p-6 lg:col-span-4 lg:p-8"
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <div
          className={
            hasIntro
              ? "border border-primary bg-surface p-3 lg:col-span-8 lg:col-start-5 lg:p-6"
              : "border border-primary bg-surface p-3 lg:col-span-8 lg:p-6"
          }
        >
          <AccordionList items={items} openBehavior={openBehavior} />
        </div>
      </div>
    </RavioliSection>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
